import { render, staticRenderFns } from "./PluginInstructions.vue?vue&type=template&id=d5573d5e&scoped=true"
import script from "./PluginInstructions.vue?vue&type=script&lang=js"
export * from "./PluginInstructions.vue?vue&type=script&lang=js"
import style0 from "./PluginInstructions.vue?vue&type=style&index=0&id=d5573d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5573d5e",
  null
  
)

export default component.exports